import { ref, watch } from 'vue';

const defaultTitle = 'VECT';
const currentTitle = ref(defaultTitle);

export function useTitle() {
  const setTitle = (newTitle) => {
    const prefix = process.env.VUE_APP_MODE === 'development' ? 'Test - ' : '';
    currentTitle.value = newTitle ? `${prefix}${newTitle} - ${defaultTitle}` : `${prefix}${defaultTitle}`;
  };

  watch(currentTitle, (newVal) => {
    document.title = newVal;
  }, { immediate: true }); // Set on initial load

  return { setTitle };
}